<template>
  <div class="container">
    <iframe
      src="http://t.ymt.com/1yr733k?code=HynT90wQkDpbXOPRscBQ1ZL1tmSBdG27f9P8pLWSZkEWqM3Pc9RyKbYDhOGs&client_id=10009"
      frameborder="0"
      class="iframe"
    ></iframe>
    <main-title :arrowClick="true">
      <template v-slot:rightBtn></template>
    </main-title>
    <hright-side></hright-side>
    <lengend-bar />
  </div>
</template>

<script>
const lengendBar = () => import("./page/legendBar");
const hrightSide = () => import("@/components/hrightSide");
export default {
  components: {
    lengendBar,
    hrightSide
  }
};
</script>

<style lang="stylus" scoped>
.container
  width 100%
  height 100vh
  position relative
  overflow hidden
  >>>.header
    top 0
  .iframe
    width 100%
    height 100%
</style>
